module.exports = __webpack_public_path__ + "e6b44348f68adb801d9c6821a2d1e50a.png";